import OriginClient from '@clarity-website/lib/clients/OriginClient';
import { useMemo } from 'react';

export default function useOriginClient() {
  return useMemo(() => new OriginClient(), []);
}
